import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";

const Geography = () => {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Geography</h1>
        <p className="text-muted-foreground">
          Geographic distribution of sales and customers.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Geographic Overview</CardTitle>
          <CardDescription>
            View sales distribution across different regions and countries.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-96 flex items-center justify-center">
            <p className="text-muted-foreground">Geography chart will be displayed here</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Geography;
